import { Typography } from '@material-ui/core';
import { Link as RRLink } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import SetUpProject1 from './../../assets/SetUpProject-1.png';
import SetUpProject2 from './../../assets/SetUpProject-2.png';
import SetUpProject3 from './../../assets/SetUpProject-3.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function SetupProject() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.projects.label'),
          helpTopicId: 'projects',
          topicName: t('help.subtopics.setupProject'),
          topicNameId: 'setup-project'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.setupProject.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.setupProject.step1')}</Typography>
      <img
        className={classes.media}
        src={SetUpProject1}
        alt={`${String(t('help.stepAltPrefix'))}1`}
      />
      <Typography variant="body1">{t('help.pages.setupProject.step2')}</Typography>
      <img
        className={classes.media}
        src={SetUpProject2}
        alt={`${String(t('help.stepAltPrefix'))}2`}
      />
      <Typography variant="body1">{t('help.pages.setupProject.step3')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProject.step31')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProject.step32')}{' '}
        <RRLink to="/helps/permissions/user-access-control">
          {t('help.links.whatIsUserAccessControl')}
        </RRLink>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProject.step33')}
      </Typography>
      <img
        className={classes.media}
        src={SetUpProject3}
        alt={`${String(t('help.stepAltPrefix'))}3`}
      />
      <Typography variant="body1">{t('help.pages.setupProject.step4')}</Typography>
      <HelpFooter />
    </div>
  );
}
